import _ from "../../utils/lodashUtils"
import { FIREBASE_STATE_KEYS, FirebaseService } from "../../firebase"

export const getUserAndPartnerCartDetails = (userState, partnerState) => {
  const userDetails = {}
  const partnerDetails = {}
  // Read the data frpom firebase
  userDetails["cart"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`,
    {}
  )
  userDetails["displayName"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DISPLAY_NAME}`
  )
  userDetails["last_name"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.last_name`
  )
  partnerDetails["cart"] = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`,
    {}
  )
  partnerDetails["displayName"] = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DISPLAY_NAME}`
  )
  partnerDetails["last_name"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.last_name`
  )
  return { userDetails: userDetails, partnerDetails: partnerDetails }
}

export const goBackToPlanADate = async (
  props,
  dateState,
  userState,
  partnerState,
  isOrderCombined
) => {
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const acceptedRestaurantId =
    acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]
  const status = _.get(dateState, "payStatus.status", "")
  const user = _.get(userState, "userDetails", {})

  const isPayingForBoth =
    _.get(dateState, "payStatus.userPickedTab") === _.get(user, "uuid", "") &&
    status === "BOTH"
  if (acceptedRestaurantId) {
    await props.emptyDeliveryDotComCart(
      acceptedRestaurantId,
      false,
      isOrderCombined,
      isPayingForBoth,
      false
    )
    await FirebaseService.write(
      {
        [FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT]: null,
        [FIREBASE_STATE_KEYS.PAY_STATUS]: null,
        [FIREBASE_STATE_KEYS.IS_ORDER_COMBINED]: isOrderCombined,
        [FIREBASE_STATE_KEYS.RESET_ORDER]: null,
        [FIREBASE_STATE_KEYS.STATUS]: "ACTIVE",
        [userState.userDetails.uuid]: {
          [FIREBASE_STATE_KEYS.DELIVERY_COM_CART]: null,
          [FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT]: null,
          [FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT]: null,
          [FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID]: null,
          [FIREBASE_STATE_KEYS.USER_DETAILS]: userState.userDetails,
          [FIREBASE_STATE_KEYS.PRESENCE]: userState.presence,
          [FIREBASE_STATE_KEYS.SHARED_PROFILE_ANSWERS]: _.get(
            userState,
            "sharedProfileAnswers",
            {}
          ),
        },
        [partnerState.userDetails.uuid]: {
          [FIREBASE_STATE_KEYS.DELIVERY_COM_CART]: null,
          [FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT]: null,
          [FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT]: null,
          [FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID]: null,
          [FIREBASE_STATE_KEYS.USER_DETAILS]: partnerState.userDetails,
          [FIREBASE_STATE_KEYS.PRESENCE]: partnerState.presence,
          [FIREBASE_STATE_KEYS.SHARED_PROFILE_ANSWERS]: _.get(
            partnerState,
            "sharedProfileAnswers",
            {}
          ),
        },
        [FIREBASE_STATE_KEYS.MEMBERS]: dateState.members,
        [FIREBASE_STATE_KEYS.PLAN_A_DATE]: false,
        [FIREBASE_STATE_KEYS.RESET_ORDER]: true,
      },
      `${FirebaseService.getDefaultPath()}`
    )
  }

  FirebaseService.setActiveRoute("/plan-new-date")
  props.history.push("/plan-new-date")
}
